import { Context } from '@/models/order-history/status/context/context'
import { ReorderAcceptableError } from '@/models/order-history/status/context/history-error'
import { filterNpCreditError, filterNpProfileError } from '@/models/order-history/status/context/history-error/np-postpay'
import {
  ReorderAcceptabilityState,
  reorderNotAcceptableState,
} from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state'
import {
  createReorderPaymentPath,
  createReorderProfilePath,
} from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state/create-reorder-path'
import { CreateStateCommand } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state/create-state-command'

interface ApplicableContext extends Context {
  paymentType: 'np-postpay'
}

/**
 * @internal モジュールの外部からはgetReorderAcceptabilityStateを利用すること
 */
export class CreateStateCommandForNpPostpay extends CreateStateCommand<ApplicableContext> {
  shouldApply(context: Pick<Context, 'paymentType'>): context is ApplicableContext {
    return context.paymentType === 'np-postpay'
  }
  protected createState(
    context: Pick<Context, 'engineStatus' | 'historyErrorList'>
  ): ReorderAcceptabilityState {
    if (context.engineStatus !== 'payment-error') {
      return reorderNotAcceptableState
    }

    const profileError = filterNpProfileError(context.historyErrorList).head
    if (profileError) {
      return {
        id: 'np-profile-error',
        acceptable: true,
        createReorderPath: createReorderProfilePath,
        view: {
          buttonLabel: '修正する',
          description: getProfileErrorDescription(profileError),
        },
      }
    }
    const creditError = filterNpCreditError(context.historyErrorList).head
    if (creditError) {
      return {
        id: 'np-credit-error',
        acceptable: true,
        createReorderPath: createReorderPaymentPath,
        view: {
          buttonLabel: '修正する',
          description: getCreditErrorDescription(creditError),
        },
      }
    }

    return reorderNotAcceptableState
  }
}

function getProfileErrorDescription(error: ReorderAcceptableError): string[] {
  const { reorderLimitDate } = error
  if (reorderLimitDate) {
    return [
      '氏名、配送先、または電話番号に不備がありますので修正してください。',
      `${reorderLimitDate.toLocaleDateString()}までに変更いただけない場合、注文は自動的にキャンセルとなります。`,
    ]
  }

  return ['氏名、配送先、または電話番号に不備がありますので修正してください。']
}

function getCreditErrorDescription(error: ReorderAcceptableError): string[] {
  const { reorderLimitDate } = error
  if (reorderLimitDate) {
    return [
      'お支払い方法を変更してください。',
      `${reorderLimitDate.toLocaleDateString()}までに変更いただけない場合、注文は自動的にキャンセルとなります。`,
    ]
  }

  return ['お支払い方法を変更してください。']
}
